'use client';

import React from 'react';
import { useCart } from '../../context/cartContext';
import { Product } from '../hiv-test/types';
import AnimatedGradientButton from './shared/AnimatedGradientButton';

interface AddToCartButtonProps {
  buttonText?: string;
  className?: string;
  product?: Product | null;
}

const AddToCartButton = ({
  buttonText = 'Add to Cart',
  className = 'w-full sm:w-[180px]',
  product,
}: AddToCartButtonProps) => {
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    if (product) {
      addToCart({
        id: product.id,
        image: product.featuredImage || {
          altText: 'Product image',
          url: '/trusti-kit-unboxing.png',
        },
        merchandiseId: product.variants.edges[0].node.id,
        price: product.priceRange.minVariantPrice.amount,
        quantity: 1,
        title: product.title,
        variantTitle: product.variants.edges[0].node.title,
      });
    } else {
      throw new Error('Product is required to add to cart');
    }
  };

  return (
    <AnimatedGradientButton
      flatHover={true}
      as="button"
      onClick={handleAddToCart}
      className={className}
    >
      {buttonText}
    </AnimatedGradientButton>
  );
};

export default AddToCartButton;
